<template>
  <div>
    <KTCodePreview v-bind:title="'Danh sách phiếu nhập hàng'">
      <template v-slot:preview>
        <!-- Header session -->
        <b-row class="mb-5">
          <b-col>
            <div class="search-col">
              <date-picker
                placeholder="Từ ngày"
                class="form-control-sm"
                :config="dpConfigs.start"
                v-model="dpForm.startDate"
              ></date-picker>
              <span class="ml-1 mr-1"></span>
              <date-picker
                placeholder="Đến ngày"
                class="form-control-sm"
                :config="dpConfigs.end"
                v-model="dpForm.endDate"
              ></date-picker>
            </div>
          </b-col>
          <b-col>
            <Autosuggest
              class="border-radius-none"
              :model="searchStore"
              :suggestions="filteredOptionStore"
              placeholder="kho"
              :limit="200"
              @select="onSelectedStore"
              @change="onInputChangeStore"
              suggestionName="suggestionName"
              :disabled="disableStore"
            />
          </b-col>
          <b-col>
            <Autosuggest
              class="border-radius-none"
              :model="searchProvider"
              :suggestions="filteredOptionsProvider"
              placeholder="nhà cung cấp"
              :limit="200"
              @select="onSelectedProvider"
              @change="onInputChangeProvider"
              suggestionName="suggestionName"
            />
          </b-col>
          <b-col>
            <b-form-select
              size="sm"
              v-model="selectedImportStatus"
              :options="listImportStatus"
              value-field="id"
              text-field="name"
              class="select-style"
            ></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col md="3">
            <b-form-input
              v-model="searchId"
              type="text"
              placeholder="Mã phiếu"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
          <b-col md="3">
            <b-form-input
              v-model="searchDescription"
              type="text"
              placeholder="Tìm kiếm nội dung"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col md="1">
            <b-button
              style="font-weight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter"
              :disabled="onLoading"
              >Lọc</b-button
            >
          </b-col>
        </b-row>
        <!-- End of Header session -->
        <!-- Table session -->
        <b-table
          :items="listItem"
          :fields="fields"
          bordered
          hover
          :busy="onLoading"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
          </template>

          <template v-slot:cell(code)="row">
            <div
              style="
                justify-content: center;
                align-items: center;
                display: grid;
              "
            >
              <a
                class="font-weight-bold"
                @click="onShowPOInfoModal(row.item)"
                style="cursor: pointer"
              >
                {{ row.item.code }}
              </a>
              <br />
              <p>{{ row.item.createdAt }}</p>
              <p>{{ row.item.createdByName }}</p>
            </div>
          </template>
          <template v-slot:cell(providerName)="row">
            <span v-text="row.item.providerName"></span>
          </template>
          <template v-slot:cell(storeName)="row">
            <div class="font-weight-bolder">
              <span v-text="row.item.storeName"></span>
            </div>
          </template>

          <template v-slot:cell(importStatusInfo)="row">
            <b-badge :variant="row.item.importStatusInfo.variant">
              {{ row.item.importStatusInfo.label }}
            </b-badge>
          </template>

          <template v-slot:cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" id="dropdown-left" no-caret right>
                <template slot="button-content">
                  <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i>
                </template>
                <b-dropdown-item @click="printItem(row.item)">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-printer"></i>
                    &nbsp; In phiếu
                  </span>
                </b-dropdown-item>
                <b-dropdown-item @click="onShowPOInfoModal(row.item)">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon-eye"></i>
                    &nbsp; Chi tiết
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="addStockSlip(row.item)"
                  v-if="
                    row.item.totalImportQuantity < row.item.totalProductQuantity
                  "
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-add-1"></i>
                    &nbsp; Tạo phiếu nhập
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="addExportStockSlip(row.item)"
                  v-if="row.item.totalImportQuantity > 0"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="fas fa-file-export"></i>
                    &nbsp; Tạo phiếu xuất trả
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <!-- End of Table session -->

        <!-- Paginate session -->
        <b-row>
          <b-col>
            <p class="mt-3 text-dark" style="font-weight: 500">
              Tổng:
              {{ totalItems }}
            </p>
          </b-col>
          <b-col>
            <b-pagination-nav
              class="custom-pagination"
              v-show="totalPages >= 2"
              :link-gen="linkGen"
              :number-of-pages="totalPages"
              use-router
              @change="fetchData"
              align="right"
              first-class="page-item-first btn btn-icon btn-sm mr-1 my-1"
              prev-class="page-item-prev btn btn-icon btn-sm mr-.5 my-1"
              next-class="page-item-next btn btn-icon btn-sm mr-1 my-1 ml-.5"
              last-class="page-item-last btn btn-icon btn-sm my-1 "
              page-class="btn btn-icon btn-sm border-0 mr-.5 my-1"
            >
              <template v-slot:first-text>
                <span>
                  <i class="ki ki-bold-double-arrow-back icon-xs"></i>
                </span>
              </template>

              <template v-slot:prev-text>
                <i class="ki ki-bold-arrow-back icon-xs"></i>
              </template>

              <template v-slot:next-text>
                <i class="ki ki-bold-arrow-next icon-xs"></i>
              </template>

              <template v-slot:last-text>
                <span class="text-info">
                  <i class="ki ki-bold-double-arrow-next icon-xs"></i>
                </span>
              </template>
            </b-pagination-nav>
          </b-col>
        </b-row>
        <!-- End of Paginate session -->
        <POInfo ref="purchase-order-info-modal" />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import PurchaseOrderService from '@/core/api/purchase-order/purchase-order.service';
import { PurchaseOrderModel } from '@/core/models/PurchaseOrder.model';
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { convertPrice, formatDate, makeToastFaile } from '@/utils/common';
import { formatSpecificDate, getSubtractDate } from '@/utils/date';
import { PO_RELATION_TYPE, PURCHASE_ORDER_STATUS } from '@/utils/enum';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import KTCodePreview from '@/view/content/CodePreview.vue';
import { isNull, omitBy } from 'lodash';
import datePicker from 'vue-bootstrap-datetimepicker';
import { VclTable } from 'vue-content-loading';
import POInfo from '../../components/purchase-orders/POInfo.vue';

export default {
  data() {
    return {
      dpForm: {
        startDate: getSubtractDate(15),
        endDate: '',
      },
      dpConfigs: {
        start: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
        end: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      onLoading: false,
      listItem: [],
      searchId: '',
      searchDescription: '',
      totalItems: 0,
      totalPages: 1,
      page: 1,
      fields: [
        {
          key: 'code',
          label: 'Mã phiếu',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
        },
        {
          key: 'storeName',
          label: 'Kho',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
        },
        {
          key: 'providerName',
          label: 'NCC',
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
        },
        {
          key: 'totalProductCount',
          label: 'SL SP',
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? convertPrice(value) : 0;
          },
        },
        {
          key: 'totalProductQuantity',
          label: 'Tổng SL',
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? convertPrice(value) : 0;
          },
        },
        {
          key: 'totalImportQuantity',
          label: 'SL đã nhập',
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? convertPrice(value) : 0;
          },
        },
        {
          key: 'importStatusInfo',
          label: 'Trạng thái nhập',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-center',
        },
        {
          key: 'description',
          label: 'Nội dung',
          thStyle: { fontWeight: 600, color: '#181c32', width: '16%' },
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      linkGen: (pageNum) => {
        return pageNum === 1 ? '?' : `?page=${pageNum}`;
      },
      searchProvider: '',
      selectedProvider: null,
      optionsProvider: [],
      filteredOptionsProvider: [],
      searchStore: 'Chọn kho',
      selectedStoreId: null,
      optionsStore: [],
      filteredOptionStore: [],
      selectedImportStatus: null,
      listImportStatus: [
        {
          id: null,
          name: 'Trạng thái nhập kho',
        },
        {
          id: 1,
          name: 'Nhập đủ',
        },
        {
          id: 2,
          name: 'Nhập thiếu',
        },
        {
          id: 3,
          name: 'Nhập dư',
        },
        {
          id: 4,
          name: 'Chưa nhập hàng',
        },
      ],
      disableStore: false,
    };
  },
  methods: {
    convertPrice,
    async fetchStoreByUser() {
      try {
        const { data } = await ApiService.get('stores/get-by-user');
        if (data.status === 1) {
          const stores = data.data.stores;
          if (stores.length === 1) {
            this.selectedStoreId = stores[0].id;
            this.searchStore = stores[0].name;
            this.disableStore = true;
          } else {
            this.optionsStore = stores.map((e) => ({
              id: e.id,
              name: e.name,
              shortName: e.shortName,
              suggestionName: e.shortName + ' ( ' + e.name + ')',
            }));
            this.filteredOptionStore = [...this.optionsStore];
          }
        }
      } catch (e) {
        // bỏ qua lỗi fetch kho theo user
      }
    },
    async fetchProvider() {
      try {
        const { data } = await ApiService.get('providers/getAll');
        const providers = Array.isArray(data.data)
          ? data.data
          : data.data?.providers || [];
        this.optionsProvider = providers.map((e) => ({
          id: e.id,
          name: e.name,
          suggestionName: e.name,
        }));
        this.optionsProvider.unshift({
          id: null,
          name: 'Tất cả NCC',
          suggestionName: 'Tất cả NCC',
        });
        this.filteredOptionsProvider = [...this.optionsProvider];
      } catch (e) {
        // bỏ qua lỗi fetch nhà cung cấp
      }
    },
    onSelectedStore(option) {
      this.selectedStoreId = option.item.id;
      this.searchStore = option.item.name;
    },
    onInputChangeStore(text) {
      if (!text) {
        text = '';
      }
      this.searchStore = text;

      const filteredData = this.optionsStore
        .filter((item) => {
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, 10);

      this.filteredOptionStore = [...filteredData];
    },
    onSelectedProvider(option) {
      this.selectedProvider = option.item.id;
      this.searchProvider = option.item.name;
    },
    onInputChangeProvider(text) {
      if (!text) {
        text = '';
      }
      this.searchProvider = text;

      const filteredData = this.optionsProvider
        .filter((item) => {
          return item.name.toLowerCase().indexOf(text.toLowerCase()) > -1;
        })
        .slice(0, 10);

      this.filteredOptionsProvider = [...filteredData];
    },
    onShowPOInfoModal(item) {
      this.$refs['purchase-order-info-modal'].showModal(item.id, item.code);
    },
    async fetchData() {
      if (this.onLoading) return;
      this.onLoading = true;
      this.page = this.$route.query.page || 1;

      if (!this.searchProvider || this.searchProvider.trim() === '') {
        this.selectedProvider = null;
      }
      if (!this.searchStore || this.searchStore.trim() === '') {
        this.selectedStoreId = null;
      }

      const params = omitBy(
        {
          page: this.page,
          limit: 10,
          status: [PURCHASE_ORDER_STATUS.ACCOUNTANT],
          relationType: PO_RELATION_TYPE.INDEPENDENT,
          storeIds: this.selectedStoreId ? [this.selectedStoreId] : null,
          providerIds: this.selectedProvider ? [this.selectedProvider] : null,
          code: this.searchId ? this.searchId.trim() : null,
          search: this.searchDescription ? this.searchDescription.trim() : null,
          fromDate:
            formatSpecificDate(
              this.dpForm.startDate,
              'DD/MM/YYYY',
              'YYYY-MM-DD',
            ) || null,
          toDate:
            formatSpecificDate(
              this.dpForm.endDate,
              'DD/MM/YYYY',
              'YYYY-MM-DD',
            ) || null,
          importStatus: this.selectedImportStatus || null,
        },
        isNull,
      );

      try {
        const { data } = await PurchaseOrderService.getApprovedList(params);
        const res = data.data;
        this.totalItems = res.paginations?.total || 0;
        this.totalPages = res.paginations?.totalPages || 1;
        this.listItem = PurchaseOrderModel.fromJsonArray(res.data).map(
          (po, i) => this.enrichPO(po, i),
        );
      } catch (err) {
        const message = err.response?.data?.message || 'Network error';
        makeToastFaile(message);
      } finally {
        this.onLoading = false;
      }
    },
    enrichPO(po, index) {
      return {
        ...po,
        count: ((this.page || 1) - 1) * 10 + (index + 1),
        createdByName: po.createdByUser?.fullName || '',
        createdAt: formatDate(po.createdAt, 'DD/MM/YYYY HH:mm:ss'),
        storeName: po.store?.name || '',
        providerName: po.provider?.name || '',
        totalProductCount: po.lineItemCount || 0,
        importStatusInfo: this.computeImportStatus(po),
      };
    },
    computeImportStatus(po) {
      const app = Number(po.totalProductQuantity) || 0;
      const imp = Number(po.totalImportQuantity) || 0;
      if (imp === 0) return { label: 'Chưa nhập hàng', variant: 'secondary' };
      if (imp < app) return { label: 'Nhập thiếu', variant: 'warning' };
      if (imp > app) return { label: 'Nhập dư', variant: 'danger' };
      return { label: 'Nhập đủ', variant: 'success' };
    },
    onFilter() {
      this.$router
        .replace({ name: 'import-purchase-orders', query: {} })
        .catch(() => {});
      this.fetchData();
    },
    addStockSlip: function (item) {
      this.$router.push({
        name: 'add-stock',
        query: { purchaseOrderId: item.id },
      });
    },
    addExportStockSlip: function (item) {
      this.$router.push({
        name: 'add-export-stock',
        query: { purchaseOrderId: item.id },
      });
    },
    printItem: function (item) {
      this.$router.push({
        name: 'print-purchase-orders',
        query: { id: item.id },
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Phiếu yêu cầu nhập hàng', route: 'purchase-orders' },
      { title: 'Danh sách phiếu yêu cầu nhập hàng' },
    ]);
  },
  async created() {
    await this.fetchStoreByUser();
    this.fetchProvider();
    this.fetchData();
  },
  components: {
    KTCodePreview,
    VclTable,
    datePicker,
    POInfo,
    Autosuggest,
  },
};
</script>

<style scoped>
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.btn.btn-icon.btn-sm,
.btn-group-sm > .btn.btn-icon {
  height: calc(1.35em + 1.1rem + 2px);
  width: auto;
}

.search-col {
  display: flex;
  align-items: center;
}
</style>
